import React, { useState, useRef, useEffect, useMemo } from "react";
import { getTileImage, getTileTitle } from "../../utils";
import ImageWithSpinner from "./ImageWithSpinner";
import {
  faArrowAltCircleLeft,
  faArrowAltCircleRight,
  faCheck,
  faChevronRight,
  faEllipsisH,
  faPencil,
  faXmark,
} from "@fortawesome/free-solid-svg-icons";
import { useLocation } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { PAGINATION_OFFSET } from "../../utils/general";
import Loader from "./Loader";
import TemplateDropdownMenu from "../templates/TemplateMenu";
import InfiniteScroll from "react-infinite-scroll-component";
import { Tabs } from "../Tabs";
import { useSelector } from "react-redux";
import { TEMPLATE_LAYOUT } from "../../constants/dashboard";
import { useNavigate } from "react-router-dom";
import CreateVideoCard from "./CreateVideoCard";
import {
  upDateTemplateTitle,
  updateVideoTemplateTitle,
} from "../../thunks/dashboardThunks";
import { useDispatch } from "react-redux";

function RailItem({
  imageUrl,
  title,
  onClick,
  isFavorite,
  isUserTemplate,
  isVideoTemplate,
  id,
  layout,
  showEditTitle = true,
  user,
  setEditTitleId = () => {},
  editTitleId,
  onTitleChange = () => {},
}) {
  const [aspectRatioHeight, setAspectRatioHeight] = useState(0);
  const imageContainerRef = useRef(null);
  const [input, setInput] = useState(title);
  const menuRef = useRef(null);
  const { isAdmin } = useSelector((state) => state.user);

  const [openMenu, setOpenMenu] = useState(false);

  useEffect(() => {
    const handleClose = (e) => {
      if (!(menuRef.current && menuRef.current.contains(e.target))) {
        toggleMenu(false);
      }
    };
    document.addEventListener("click", handleClose, false);
    return () => document.addEventListener("click", handleClose, false);
  }, []);

  useEffect(() => {
    if (imageContainerRef.current) {
      const width = imageContainerRef.current.offsetWidth;
      const height = (width / 16) * 9; // Calculate the height based on 16:9 aspect ratio
      setAspectRatioHeight(height); // Set the height state
    }
  }, [imageContainerRef]);

  const toggleMenu = (value) => setOpenMenu((prev) => value ?? !prev);
  return (
    <div
      ref={imageContainerRef}
      className={`relative mt-2 ${
        layout === TEMPLATE_LAYOUT.VERTICAL
          ? "h-[180px] w-[117px] aspect-[117/180]"
          : "w-[270px] h-[157px] aspect-[275/160]"
      } inline-block hover:border-solid  rounded-lg bg-white`}
      onClick={() => toggleMenu(false)}
    >
      <div
        className="relative w-full h-full hover:cursor-pointer"
        onClick={onClick}
      >
        {isVideoTemplate ? (
          <video
            src={imageUrl}
            className="absolute top-0 left-0 w-full h-full object-cover rounded-lg cursor-pointer"
          />
        ) : (
          <ImageWithSpinner
            src={imageUrl}
            alt={title}
            className="absolute top-0 left-0 w-full h-full object-cover rounded-lg cursor-pointer"
          />
        )}
      </div>
      {isFavorite && (
        <img
          className="cursor-pointer w-4 h-4 bg-gradient p-[2px] rounded-[50%]  absolute top-2 left-2 text-white"
          src="/tool/dashboard/static/images/icons/tools/like.svg"
        />
      )}
      {(!!isAdmin || isUserTemplate || isVideoTemplate) && (
        <FontAwesomeIcon
          ref={menuRef}
          icon={faEllipsisH}
          className="cursor-pointer bg-slides-label rounded-sm w-6 h-4  absolute top-2 right-2 text-white"
          onClick={(e) => {
            e.stopPropagation();
            return toggleMenu();
          }}
        />
      )}
      {openMenu && (
        <div
          className="z-50 overflow-auto"
          onClick={(e) => {
            e.stopPropagation();
            toggleMenu();
          }}
        >
          <TemplateDropdownMenu
            template={{ id }}
            handleClose={toggleMenu}
            isUserTemplate={isUserTemplate}
            className="left-[50%] top-[0%] w-[188px] h-auto shadow z-50 "
            isFavorite={isFavorite}
            isVideoTemplate={isVideoTemplate}
            handleEditTitle={() => setEditTitleId(id)}
            showTitleEdit={showEditTitle}
          />
        </div>
      )}
      {(!editTitleId || editTitleId !== id) && (
        <div className={`flex justify-between items-center mt-2`}>
          <p className="text-xs text-gray-500 truncate">{title}</p>
          {showEditTitle && (
            <FontAwesomeIcon
              icon={faPencil}
              className="cursor-pointer ml-1"
              size={"xs"}
              onClick={() => {
                setEditTitleId(id);
              }}
            />
          )}
        </div>
      )}
      {editTitleId === id && (
        <div className="flex gap-2 items-center">
          <input
            autoFocus
            type="text"
            placeholder="Enter title"
            className="w-full h-6 border border-gray-300 rounded-lg px-2 text-sm mt-1"
            value={input}
            onChange={(e) => setInput(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === "Enter" && !!input) {
                onTitleChange(id, user, input);
                setEditTitleId("");
              }
            }}
          />
          <div className="flex gap-2">
            <FontAwesomeIcon
              icon={faXmark}
              className="cursor-pointer"
              size={"xs"}
              onClick={() => {
                setEditTitleId("");
              }}
            />
            <FontAwesomeIcon
              icon={faCheck}
              className="cursor-pointer"
              size={"xs"}
              onClick={() => {
                if (!!input) {
                  onTitleChange(id, user, input);
                  setEditTitleId("");
                }
              }}
            />
          </div>
        </div>
      )}
    </div>
  );
}
const Rail = ({
  items,
  railTitle,
  onClicked,
  totalCount = 0,
  fetchMore,
  loading,
  isUserTemplate,
  isVideoTemplate,
  isSlider,
  hasMore,
  tabs,
  handleTabChange,
  myProject,
  isDashboard,
  key,
  isFeatureTemplate,
}) => {
  const navigation = useNavigate();
  const dispatch = useDispatch();
  const { activeLayout } = useSelector((state) => state.templates);
  const scrollContainer = useRef(null);
  const hasNext = totalCount !== items.length;
  const [editTitleId, setEditTitleId] = useState("");

  const upDateCardTitle = (id, user, title) => {
    if (isVideoTemplate) {
      return dispatch(updateVideoTemplateTitle(id, user, title));
    }
    return dispatch(upDateTemplateTitle(id, user, title));
  };

  const noTemplates = useMemo(
    () => !loading && !(items || []).length,
    [loading, items]
  );

  const scrollRight = () => {
    if (scrollContainer.current) {
      scrollContainer.current.scrollBy({ left: 150, behavior: "smooth" });
      const hasNext = totalCount !== items.length;
      if (totalCount && fetchMore && hasNext) {
        checkThreshold();
      }
    }
  };

  const scrollLeft = () => {
    if (scrollContainer.current) {
      scrollContainer.current.scrollBy({ left: -150, behavior: "smooth" });
    }
  };

  const checkThreshold = () => {
    const currentPage = items.length / PAGINATION_OFFSET;

    if (
      !loading &&
      scrollContainer.current &&
      scrollContainer.current.scrollLeft >= (items.length - 6) * 150
    ) {
      return fetchMore(currentPage);
    }
  };

  const infinateScroll = () => {
    const currentPage = items.length / PAGINATION_OFFSET;
    return fetchMore(currentPage, true);
  };

  const location = useLocation();
  const isTheme = useMemo(() => {
    return location.pathname.includes("/templates");
  }, []);

  return (
    <>
      <div className="mt-4 mb-2 p-2 flex items-center gap-4 justify-between">
        <div className="flex gap-4 items-center">
          {railTitle && (
            <h2 className="text-sm font-weight-400 ">{railTitle}</h2>
          )}
          {tabs && handleTabChange && (
            <Tabs
              tabs={tabs}
              handleTabChange={handleTabChange}
              currentActiveTab={activeLayout}
            />
          )}
        </div>
        {isDashboard && !noTemplates && (
          <button onClick={() => navigation("/projects")}>
            See All{" "}
            <span>
              <FontAwesomeIcon icon={faChevronRight} />
            </span>
          </button>
        )}
      </div>
      <div className="mb-3 space-x-4  flex items-center">
        {!!(items || []).length && isSlider && (
          <span
            className="text-gray-400 cursor-pointer mr-2"
            onClick={scrollLeft}
          >
            <FontAwesomeIcon
              icon={faArrowAltCircleLeft}
              className="mr-2 text-gray-800 hover:text-vb-pink"
            />
          </span>
        )}
        {/* {loading && !isSlider && <Loader isDark isStack hideOverlay />} */}

        {isFeatureTemplate ? (
          <>
            {!!loading && !(items || []).length && (
              <Loader
                className="flex item-center justify-center !w-full"
                isDark
                isStack
                hideOverlay
              />
            )}
            <InfiniteScroll
              dataLength={items.length}
              next={infinateScroll}
              hasMore={hasMore}
              loader={<Loader isDark isStack hideOverlay />}
            >
              <div className="flex flex-wrap gap-6">
                {(items || []).map((item, index) => (
                  <RailItem
                    {...item}
                    key={item.id}
                    showEditTitle={!isTheme}
                    imageUrl={getTileImage(item)}
                    setEditTitleId={setEditTitleId}
                    editTitleId={editTitleId}
                    title={getTileTitle(item)}
                    user={item.user}
                    onClick={() => onClicked(item)}
                    isUserTemplate={isUserTemplate}
                    isVideoTemplate={isVideoTemplate}
                    onTitleChange={upDateCardTitle}
                  />
                ))}
              </div>
            </InfiniteScroll>
          </>
        ) : (
          <>
            <div
              id="scrollableDiv"
              ref={scrollContainer}
              className={
                isSlider
                  ? "mx-4 whitespace-nowrap space-x-4 overflow-x-auto scroll-container  items-center"
                  : `overflow-y-auto overflow-x-hidden  ${
                      isVideoTemplate ? `h-[600px]` : `h-[400px]`
                    }  p-2 w-[100%]`
              }
            >
              {noTemplates ? (
                <div className="flex flex-grow text-sm text-gray-500 items-center text-center w-full">
                  <CreateVideoCard />
                </div>
              ) : !isSlider && !!loading && !(items || []).length ? (
                <Loader
                  className="flex item-center justify-center"
                  isDark
                  isStack
                  hideOverlay
                />
              ) : !isSlider ? (
                isDashboard ? (
                  <div
                    className={`flex flex-wrap gap-6 ${
                      !myProject ? "overflow-y-auto" : "overflow-y-hidden"
                    }  flex-row h-full  w-[100%] `}
                  >
                    {(items || []).map((item, index) => (
                      <RailItem
                        {...item}
                        showEditTitle={!isTheme}
                        key={item.id}
                        setEditTitleId={setEditTitleId}
                        editTitleId={editTitleId}
                        imageUrl={getTileImage(item)}
                        title={getTileTitle(item)}
                        onClick={() => onClicked(item)}
                        user={item.user}
                        isUserTemplate={isUserTemplate}
                        isVideoTemplate={isVideoTemplate}
                        onTitleChange={upDateCardTitle}
                      />
                    ))}
                  </div>
                ) : (
                  <InfiniteScroll
                    dataLength={items.length}
                    next={infinateScroll}
                    hasMore={hasMore}
                    loader={<Loader isDark isStack hideOverlay />}
                    scrollableTarget="scrollableDiv"
                  >
                    <div
                      className={`flex flex-wrap gap-6 ${
                        isDashboard ? "overflow-y-auto" : "overflow-y-hidden"
                      } items-center flex-row h-full  w-[100%] `}
                    >
                      {!isDashboard && !isFeatureTemplate && (
                        <CreateVideoCard />
                      )}

                      {(items || []).map((item, index) => (
                        <RailItem
                          {...item}
                          key={item.id}
                          showEditTitle={!isTheme}
                          imageUrl={getTileImage(item)}
                          setEditTitleId={setEditTitleId}
                          editTitleId={editTitleId}
                          title={getTileTitle(item)}
                          user={item.user}
                          onClick={() => onClicked(item)}
                          isUserTemplate={isUserTemplate}
                          isVideoTemplate={isVideoTemplate}
                          onTitleChange={upDateCardTitle}
                        />
                      ))}
                    </div>
                  </InfiniteScroll>
                )
              ) : (
                (items || []).map((item, index) => (
                  <RailItem
                    {...item}
                    key={item.id}
                    showEditTitle={!isTheme}
                    imageUrl={getTileImage(item)}
                    title={getTileTitle(item)}
                    onClick={() => onClicked(item)}
                    isUserTemplate={isUserTemplate}
                    isVideoTemplate={isVideoTemplate}
                    user={item.user}
                    onTitleChange={upDateCardTitle}
                  />
                ))
              )}
            </div>
            {loading && isSlider && (
              <Loader
                className="flex item-center justify-center"
                isDark
                isStack
                hideOverlay
              />
            )}

            {!!(items || []).length && isSlider && (
              <span
                className="text-gray-400 cursor-pointer ml-2 "
                onClick={scrollRight}
              >
                <FontAwesomeIcon
                  icon={faArrowAltCircleRight}
                  className="mr-2 text-gray-800 hover:text-vb-pink"
                />
              </span>
            )}
          </>
        )}
      </div>
    </>
  );
};

export default Rail;
